'use strict';

function findNodeHandleWeb(componentOrHandle) {
  return componentOrHandle;
}
export const findNodeHandle = findNodeHandleWeb;
//# sourceMappingURL=findNodeHandle.js.map